module.exports = __webpack_public_path__ + "images/25b22b01889267ff7bb15cbec5c178442.svg";